import * as shopifyIcon from '~/assets/shops/20/Shopify.png';
import * as squareIcon from '~/assets/shops/20/square.png';
import * as amazonLogoSmall from '~/assets/shops/icons/amazon.svg';
import * as bigCommerceLogoSmall from '~/assets/shops/icons/bigcommerce.svg';
import * as channelAdvisorLogoSmall from '~/assets/shops/icons/channeladvisor.svg';
import * as ebayLogoSmall from '~/assets/shops/icons/ebay.svg';
import * as ePagesLogoSmall from '~/assets/shops/icons/epages.svg';
import * as etsyLogoSmall from '~/assets/shops/icons/etsy.svg';
import * as facebookLogoSmall from '~/assets/shops/icons/facebook.svg';
import * as godaddyLogoSmall from '~/assets/shops/icons/godaddy.svg';
import * as magentoLogoSmall from '~/assets/shops/icons/magento.svg';
import * as magentoTwoLogoSmall from '~/assets/shops/icons/magento2.svg';
import * as shopifyLogoSmall from '~/assets/shops/icons/shopify.svg';
import * as spreecommerceLogoSmall from '~/assets/shops/icons/spree.svg';
import * as squareLogoSmall from '~/assets/shops/icons/square.svg';
import * as squarespaceLogoSmall from '~/assets/shops/icons/squarespace.svg';
import * as stripeLogoSmall from '~/assets/shops/icons/stripe.svg';
import * as weeblyLogoSmall from '~/assets/shops/icons/weebly.svg';
import * as wixLogoSmall from '~/assets/shops/icons/wix.svg';
import * as wooCommerceLogoSmall from '~/assets/shops/icons/woocommerce.svg';
import * as walmartLogoSmall from '~/assets/shops/icons/walmart.svg';
import * as amazonLogo from '~/assets/shops/logos/amazon.svg';
import * as bigCommerceLogo from '~/assets/shops/logos/bigcommerce.svg';
import * as channelAdvisorLogo from '~/assets/shops/logos/channeladvisor.svg';
import * as ebayLogo from '~/assets/shops/logos/ebay.svg';
import * as ePagesLogo from '~/assets/shops/logos/epages.svg';
import * as etsyLogo from '~/assets/shops/logos/etsy.svg';
import * as facebookLogo from '~/assets/shops/logos/facebook.svg';
import * as godaddyLogo from '~/assets/shops/logos/godaddy.svg';
import * as magentoLogo from '~/assets/shops/logos/magento.svg';
import * as magentoTwoLogo from '~/assets/shops/logos/magento2.svg';
import * as shopifyLogo from '~/assets/shops/logos/shopify.svg';
import * as spreeLogo from '~/assets/shops/logos/spree.svg';
import * as squareLogo from '~/assets/shops/logos/square.svg';
import * as squarespaceLogo from '~/assets/shops/logos/squarespace.svg';
import * as stripeLogo from '~/assets/shops/logos/stripe.svg';
import * as walmartLogo from '~/assets/shops/logos/walmart.svg';
import * as weeblyLogo from '~/assets/shops/logos/weebly.svg';
import * as wixLogo from '~/assets/shops/logos/wix.svg';
import * as wooCommerceLogo from '~/assets/shops/logos/woocommerce.svg';
import * as shopifySvg from '~/assets/shops/shopify/logo-mark.svg';
import * as squareSvg from '~/assets/shops/vector/square.svg';
import * as moment from 'moment';
import Store, { StoreName, StoreStatusName } from '~/types/Store';

const shippoStore: Store = {
  objectId: '1', // fake object id
  storePlatform: {
    name: StoreName.Shippo,
  },
  status: {
    name: StoreStatusName.Connected,
    description: 'Connected',
  },
  lastSyncTime: moment(),
  objectCreated: moment(),
  name: '',
  website: '',
  isAutoFulfill: false,
  isFulfillEmailEnabled: false,
  isImportPosOrdersEnabled: false,
  expirationDate: null,
  displayName: '',
};

const csvImportStore: Store = {
  objectId: '2',
  storePlatform: {
    name: StoreName.CSV,
  },
  status: {
    name: StoreStatusName.Connected,
    description: 'Connected',
  },
  lastSyncTime: moment(),
  objectCreated: moment(),
  name: '',
  website: '',
  isAutoFulfill: false,
  isFulfillEmailEnabled: false,
  isImportPosOrdersEnabled: false,
  expirationDate: null,
  displayName: '',
};

// Display helper
interface StoreAsset {
  name: StoreName;
  logoBig: string;
  logoMark?: string;
  icon?: string;
  logoSmall?: string;
  connectLink: string;
  connectRoute?: string;
  connectPropsReq?: boolean;
  canEdit: boolean;
  supportMultiStore: boolean;
  connectDocLink?: string;
}

const amazon: StoreAsset = {
  name: StoreName.Amazon,
  logoBig: amazonLogo,
  logoSmall: amazonLogoSmall,
  connectLink: `${CONFIG.djangoBaseUrl}/amazon/setup`,
  connectRoute: '/connect/amazon',
  canEdit: true,
  supportMultiStore: true,
};

const bigcommerce: StoreAsset = {
  name: StoreName.Bigcommerce,
  logoBig: bigCommerceLogo,
  logoSmall: bigCommerceLogoSmall,
  connectLink: `${CONFIG.djangoBaseUrl}/bigcommerce/setup`,
  canEdit: true,
  supportMultiStore: true,
};

const channelAdvisor: StoreAsset = {
  name: StoreName.ChannelAdvisor,
  logoBig: channelAdvisorLogo,
  logoSmall: channelAdvisorLogoSmall,
  connectLink: `${CONFIG.djangoBaseUrl}/channeladvisor/setup`,
  canEdit: false,
  supportMultiStore: false,
};

const ebay: StoreAsset = {
  name: StoreName.eBay,
  logoBig: ebayLogo,
  logoSmall: ebayLogoSmall,
  connectLink: `${CONFIG.djangoBaseUrl}/ebay/setup`,
  canEdit: true,
  supportMultiStore: true,
};

const ePages: StoreAsset = {
  name: StoreName.ePages,
  logoBig: ePagesLogo,
  logoSmall: ePagesLogoSmall,
  connectLink: `${CONFIG.djangoBaseUrl}/epages/setup`,
  canEdit: true,
  supportMultiStore: true,
};

const etsy: StoreAsset = {
  name: StoreName.Etsy,
  logoBig: etsyLogo,
  logoSmall: etsyLogoSmall,
  connectLink: `${CONFIG.djangoBaseUrl}/etsy/setup`,
  connectRoute: '/connect/etsy',
  canEdit: true,
  supportMultiStore: true,
};

const facebook: StoreAsset = {
  name: StoreName.Facebook,
  logoBig: facebookLogo,
  logoSmall: facebookLogoSmall,
  connectLink: `${CONFIG.djangoBaseUrl}/channels/facebook/setup`,
  connectRoute: '/connect/facebook',
  canEdit: true,
  supportMultiStore: false,
};

const goDaddy: StoreAsset = {
  name: StoreName.Godaddy,
  logoBig: godaddyLogo,
  logoSmall: godaddyLogoSmall,
  connectLink: `${CONFIG.djangoBaseUrl}/onlinestore/setup`,
  canEdit: true,
  supportMultiStore: false,
};

const magento: StoreAsset = {
  name: StoreName.Magento,
  logoBig: magentoLogo,
  logoSmall: magentoLogoSmall,
  connectLink: `${CONFIG.djangoBaseUrl}/magento/setup`,
  canEdit: true,
  supportMultiStore: false,
};

const magentoTwo: StoreAsset = {
  name: StoreName.Magento_2,
  logoBig: magentoTwoLogo,
  logoSmall: magentoTwoLogoSmall,
  connectLink: `${CONFIG.djangoBaseUrl}/magento_two/setup`,
  canEdit: true,
  supportMultiStore: true,
};

const shopify: StoreAsset = {
  name: StoreName.Shopify,
  logoBig: shopifyLogo,
  logoSmall: shopifyLogoSmall,
  logoMark: shopifySvg,
  icon: shopifyIcon,
  connectLink: `${CONFIG.djangoBaseUrl}/shopify/setup`,
  connectRoute: '/connect/shopify',
  canEdit: false,
  connectPropsReq: true,
  supportMultiStore: true,
};

const spreecommerce: StoreAsset = {
  name: StoreName.Spreecommerce,
  logoBig: spreeLogo,
  logoSmall: spreecommerceLogoSmall,
  connectLink: `${CONFIG.djangoBaseUrl}/spreecommerce/setup`,
  canEdit: true,
  supportMultiStore: true,
};

const squarespace: StoreAsset = {
  name: StoreName.Squarespace,
  logoBig: squarespaceLogo,
  logoSmall: squarespaceLogoSmall,
  connectLink: `${CONFIG.djangoBaseUrl}/squarespace/setup`,
  canEdit: false,
  supportMultiStore: true,
};

const stripe: StoreAsset = {
  name: StoreName.Stripe,
  logoBig: stripeLogo,
  logoSmall: stripeLogoSmall,
  connectLink: `${CONFIG.djangoBaseUrl}/stripe/setup`,
  canEdit: true,
  supportMultiStore: false,
};

const walmart: StoreAsset = {
  name: StoreName.Walmart,
  logoBig: walmartLogo,
  logoSmall: walmartLogoSmall,
  connectLink: `${CONFIG.djangoBaseUrl}/connect/walmart`,
  connectRoute: '/connect/walmart',
  canEdit: true,
  supportMultiStore: true,
  connectDocLink:
    'https://support.goshippo.com/hc/en-us/articles/18991472509339-Connect-Your-Walmart-Store-to-Shippo',
};

const weebly: StoreAsset = {
  name: StoreName.Weebly,
  logoBig: weeblyLogo,
  logoSmall: weeblyLogoSmall,
  connectLink: `${CONFIG.djangoBaseUrl}/weebly/setup`,
  canEdit: true,
  supportMultiStore: false,
};

const wix: StoreAsset = {
  name: StoreName.Wix,
  logoBig: wixLogo,
  logoSmall: wixLogoSmall,
  connectLink: `${CONFIG.djangoBaseUrl}/wix/setup`,
  connectRoute: '/connect/wix',
  canEdit: false,
  supportMultiStore: true,
};

const wooCommerce: StoreAsset = {
  name: StoreName.WooCommerce,
  logoBig: wooCommerceLogo,
  logoSmall: wooCommerceLogoSmall,
  connectLink: `${CONFIG.djangoBaseUrl}/woocommercev2/setup`,
  canEdit: false,
  supportMultiStore: true,
};

const square: StoreAsset = {
  name: StoreName.Square,
  logoBig: squareLogo,
  logoSmall: squareLogoSmall,
  logoMark: squareSvg,
  icon: squareIcon,
  connectLink: `${CONFIG.djangoBaseUrl}/channels/square/setup`,
  canEdit: false,
  supportMultiStore: true,
};

const storeAssets: { [storeName: string]: StoreAsset } = {
  [StoreName.Amazon]: amazon,
  [StoreName.Bigcommerce]: bigcommerce,
  [StoreName.ChannelAdvisor]: channelAdvisor,
  [StoreName.eBay]: ebay,
  [StoreName.ePages]: ePages,
  [StoreName.Etsy]: etsy,
  [StoreName.Facebook]: facebook,
  [StoreName.Godaddy]: goDaddy,
  [StoreName.Magento]: magento,
  [StoreName.Magento_2]: magentoTwo,
  [StoreName.Shopify]: shopify,
  [StoreName.Spreecommerce]: spreecommerce,
  [StoreName.Square]: square,
  [StoreName.Squarespace]: squarespace,
  [StoreName.Stripe]: stripe,
  [StoreName.Walmart]: walmart,
  [StoreName.Weebly]: weebly,
  [StoreName.Wix]: wix,
  [StoreName.WooCommerce]: wooCommerce,
};

const storeNames: readonly string[] = Object.values(StoreName);

const storesInOrder: StoreName[] = [
  StoreName.Shopify,
  StoreName.Godaddy,
  StoreName.Wix,
  StoreName.Magento,
  StoreName.Magento_2,
  StoreName.Bigcommerce,
  StoreName.Etsy,
  StoreName.Spreecommerce,
  StoreName.Weebly,
  StoreName.Stripe,
  StoreName.eBay,
  StoreName.Amazon,
  StoreName.WooCommerce,
  StoreName.Squarespace,
  StoreName.ChannelAdvisor,
  StoreName.ePages,
  StoreName.Square,
  StoreName.Facebook,
  StoreName.Walmart,
];

const LAST_SYNC_HOURS_OFFSET = 12;

export {
  storeNames,
  shippoStore,
  csvImportStore,
  storeAssets,
  StoreAsset,
  storesInOrder,
  LAST_SYNC_HOURS_OFFSET,
};
